import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MeApiService } from '@core/data/api/me-api.service';
import { hasResourceAccess, resourceForRoute } from '@core/util/access-control.util';
import { selectCurrentPersona } from '@state/session/session.reducer';
import { selectAccessMatrix } from '@state/users-access/users-access.reducer';

/**
 * Blocks direct URL access to a page this caller may not open, redirecting to
 * Today. The server's own answer decides it where there is one (`/me/access`),
 * falling back to the Users & Access matrix when no API is configured. Admin
 * always passes, and unmapped routes / an unloaded matrix fail open (see the
 * access-control util).
 */
export const accessGuard: CanActivateChildFn = (_route, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const meApi = inject(MeApiService);
  const matrix = store.selectSignal(selectAccessMatrix)();
  const persona = store.selectSignal(selectCurrentPersona)();
  const resource = resourceForRoute(state.url);
  return hasResourceAccess(matrix, persona, resource, { roles: meApi.roles(), levels: meApi.levels() })
    ? true
    : router.createUrlTree(['/today']);
};
